<template>
  <div
    class="edit-password flex w-full justify-start"
    style="flex-direction: column"
  >
    <div v-if="!completed">
      <div ref="crewCrewAccountEdit" style="height: calc(100vh - 220px); overflow-y: scroll; margin: 0 1rem">
        <div style="margin: 1rem 0;" class="required aisea-text-16-400-black" >
          労務管理アプリアカウントを発行します。パスワードを設定してください。
        </div>

        <div class="flex w-full justify-start items-start crew-edit-form-row">
          <vs-input
            class="w-full"
            label="ユーザーID"
            disabled
            v-model="localData.email_address"
            name="email_address"
            :color="AISEA_COLOR.BLUE"
          />
        </div>

        <div class="flex w-full justify-start items-start crew-edit-form-row">
          <div class="w-full required">
            <vs-input
              class="w-full"
              label="パスワード（自動生成パスワード）"
              v-model="password"
              v-validate="'regex:^[a-zA-Z0-9@_.\-]+$|min:8|max:64|required'"
              name="password"
              data-vv-as="パスワード"
              :color="AISEA_COLOR.BLUE"
            />
            <span
              class="text-danger text-sm"
              style="margin-left: 0.6rem"
              v-show="errors.has('password')"
              >{{ errors.first("password") }}</span
            >
            <p class="description_label">
              ※ 任意のパスワードに変更できます。（8〜64文字の半角英数字、記号のピリオド(.)・アンダースコア(_)・ハイフン(-)・アットマーク(@)が利用可能）
            </p>
          </div>
        </div>
      </div>
      <vs-divider style="margin: 0" />
      <div class="flex w-full justify-end items-center">
        <div class="w-2/3 flex justify-end items-center">
          <div style="margin: 0.8rem">
            <vs-button
              type="flat"
              style="width: 6rem; padding: 0.4rem"
              :style="{ 'background-color': AISEA_COLOR.WHITE }"
              @click="onCancel"
              :color="AISEA_COLOR.GRAY"
              >キャンセル</vs-button
            >
          </div>
          <div style="margin: 0.8rem">
            <vs-button
              style="width: 6rem; padding: 0.4rem"
              @click="onSubmit"
              :disabled="!validateForm"
              :color="AISEA_COLOR.BLUE"
              >保存</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="p-2">
        <div class="pt-2 pb-8 aisea-text-16-400-dark-gray">パスワードを設定しました。</div>
        <div class="aisea-text-16-400-dark-gray">法人ID:  {{ enterpriseLoginKey }}</div>
        <div class="aisea-text-16-400-dark-gray">ユーザーID:  {{ accountData.login_key }}</div>
        <div class="aisea-text-16-400-dark-gray">パスワード:  {{ password }}</div>

        <div class="py-8 flex items-start">
          <div>
            <feather-icon
              icon="AlertCircleIcon"
              svg-classes="h-5 w-5"
              class="mr-2 mt-1"
            />
          </div>
          <div class="aisea-text-16-400-dark-gray">
            パスワードをメモしてください。忘れた場合はパスワード再発行となります。
          </div>
        </div>
        <div class="flex justify-end">
          <div class="">
            <vs-button
              class="flex justify-end"
              type="border"
              icon="content_copy"
              :color="AISEA_COLOR.BLUE"
              @click.stop="copyPasswordClipboard()"
              >パスワードをコピー</vs-button
            >
          </div>
        </div>

        <div class="py-8 flex items-start">
          <div>
            <feather-icon
              icon="AlertCircleIcon"
              svg-classes="h-5 w-5"
              class="mr-2 mt-1"
            />
          </div>
          <div class="aisea-text-16-400-dark-gray">
            リンク先のアプリ版マニュアルを船員に案内し、アプリのダウンロードを依頼してください。
          </div>
        </div>
        <div class="flex justify-end">
          <div class="">
            <vs-button
              class="flex justify-end"
              type="border"
              icon="menu_book"
              :color="AISEA_COLOR.BLUE"
              @click.stop="openAppManual()"
              >マニュアルを開く</vs-button
            >
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const crewAccountApi = AiseaApiFactory.get("enterpriseCrewAccount");
import { ColorMixin } from "@/mixins";
import { generatePassword } from "@/utils/PasswordUtil";

export default {
  name: "CrewAccountEdit",
  mixins: [ColorMixin],
  props: {
    inputParam: Object,
    activeSidebarCrew: Boolean,
  },
  data () {
    return {
      enterpriseCrewId: null,
      localData: null,
      accountData: null,
      error: { message: null },
      password: "",
      completed: false,
      enterpriseLoginKey: null,
      enterpriseCrewAccountId: null,
      urlAppManual: 'https://crew.aisea.net/app_manual.pdf',
    };
  },
  computed: {
    isCreate () {
      return !this.inputParam.enterprise_crew_account
    },
    title () {
      return this.isCreate ? "労務管理アプリパスワード変更" : "労務管理アプリアカウント発行"
    },
    validateForm () {
      return this.password.length !== 0 && !this.errors.any()
    }
  },
  methods: {

    async initLocalData () {
      this.enterpriseCrewId = this.inputParam.id;
      this.localData = _.cloneDeep(this.inputParam);
      this.enterpriseCrewAccountId = this.inputParam.enterprise_crew_account ? this.inputParam.enterprise_crew_account.id : null; 
      this.password = generatePassword(8);
    },

    async add (payload) {
      const res = await crewAccountApi.add(this.enterpriseCrewId, payload);
      if (!res || !res.status) {
        throw res;
      }
      this.accountData = res.data;
    },
    async update (payload) {
      const res = await crewAccountApi.update(this.enterpriseCrewId, this.enterpriseCrewAccountId, payload);
      if (!res || !res.status) {
        throw res;
      }
      this.accountData = res.data;
    },

    async copyPasswordClipboard () {
      await navigator.clipboard.writeText(this.accountData.password);
      this.$vs.notify({
        text: `パスワードをコピーしました`,
        iconPack: "feather",
        icon: "icon-check",
        color: "success"
      });
    },

    openAppManual() {
      window.open(this.urlAppManual, '_blank');
    },

    async onSubmit () {
      const msg = this.isCreate ? "アプリアカウントを発行" : "パスワード更新"
      try {

        let payload = {
          "password": this.password,
          "login_key": this.localData.email_address
        };

        this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });

        if (this.isCreate) {
          await this.add(payload);
          this.$emit('setDialogTitle', 'アカウント発行完了');
          this.$vs.notify({
            title: "船員基本情報設定",
            text: `${this.localData.name}のパスワードを設定しました。`,
            icon: "done",
            color: "success"
          });
        } else {
          await this.update(payload);
          this.$emit('setDialogTitle', 'パスワード変更完了');
          this.$vs.notify({
            title: "船員基本情報設定",
            text: `${this.localData.name}のパスワードを更新しました。`,
            icon: "done",
            color: "success"
          });
        }

        await this.$vs.loading.close();
        this.completed = true;
        this.$emit('reloadList', this.isCreate ? 'createAccountCompleted' : null);
      } catch (e) {
        console.error(e)
        this.$vs.loading.close();
        this.$vs.notify({
          title: "船員基本情報設定",
          text: `${this.localData.name}の${msg}に失敗しました。時間を空けて再度試みてください。`,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
        this.$emit('close');
      }
    },

    onCancel () {
      this.localData = {};
      this.enterpriseCrewId = null;
      this.$nextTick(() => {
        this.$emit('close');
      });
    },
  },
  created () {
    this.initLocalData();
    this.enterpriseLoginKey =  this.$store.state.auth.user.login_key;
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.edit-password {
  label {
    font-family: $aisea-font-family;
    font-size: 14px;
    font-weight: 600;
  }

  .required label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger), 1);
    }
  }

  .vs-inputx {
    color: $aisea-dark-gray !important;
    font-family: $aisea-font-family;
    font-size: 16px !important;
    font-weight: 400;
  }
  .vs-input--placeholder {
    color: $aisea-slightly-gray !important;
  }

  .v-select input {
    height: 2rem;
  }

  .description_label {
    font-size: 0.8rem;
  }

  .crew-edit-form-row {
    flex-direction: column;
    margin: 24px 0;
    padding-right: 8px;
  }

  .vs__search::placeholder {
    color: lightgray;
  }

  .vdp-datepicker input {
    padding-left: 2.4rem;
  }

  .vs-collapse-item--header {
    padding: 0;
  }
  .vs-collapse-item {
    border-bottom: none;
  }
}
</style>
